import { render, staticRenderFns } from "./AutorizarRecepcionComponent.vue?vue&type=template&id=02cef36c&"
import script from "./AutorizarRecepcionComponent.vue?vue&type=script&lang=js&"
export * from "./AutorizarRecepcionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports